import { Modal } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';

import BadgePanel from '.';
import type { BadgeBaseProps, BadgeType } from './types';

import styles from './BadgePanel.module.less';

type Props = BadgeBaseProps & {
  /**
   * Should modal show
   */
  shouldShow: boolean;
  /**
   * On hide action
   */
  onHide: () => void;
  /**
   * Security is enabled for the given project
   */
  isSecurityEnabled: boolean;
  /**
   * Default tab to be selected on open
   */
  defaultTab?: BadgeType;
};

const BadgeModal: VoidFunctionComponent<Props> = ({ locator, isSecurityEnabled, shouldShow, onHide, defaultTab = 'licenseShield' }) => (
  <Modal show={shouldShow} onHide={onHide} dialogClassName={styles.badgeModal}>
    <Modal.Header closeButton />
    <BadgePanel locator={locator} isSecurityEnabled={isSecurityEnabled} defaultTab={defaultTab} />
  </Modal>
);

export default BadgeModal;
